import { createRoot, hydrateRoot } from 'react-dom/client';
import type { ReactElement } from 'react';

/**
 * Detect whether the Inertia container already holds SSR HTML.
 * React 19 marks the node with `data-server-rendered`; some Inertia
 * fallbacks also leave a `script[data-page]` sibling that must be ignored.
 */
export function hasSsrMarkup(el: Element): boolean {
    if (el.getAttribute('data-server-rendered') === 'true') {
        return true;
    }

    for (const child of el.childNodes) {
        if (child.nodeType === Node.ELEMENT_NODE) {
            const element = child as Element;

            if (element.tagName === 'SCRIPT' && element.hasAttribute('data-page')) {
                continue;
            }

            return true;
        }

        if (child.nodeType === Node.TEXT_NODE && child.textContent?.trim()) {
            return true;
        }
    }

    return false;
}

export function mountInertiaApp(el: Element, tree: ReactElement): void {
    if (hasSsrMarkup(el)) {
        hydrateRoot(el, tree);

        return;
    }

    createRoot(el).render(tree);
}
